import type { AnnotationType } from '@/core/annotationTypes'

export const SIMPLE_TABLE_ANNOTATION_TYPE: AnnotationType = 'simple_table'
